import { useEffect, useState } from "react";
import { Header } from "../../components/laxmi/Chrome";
import { api, money, when } from "../../lib/api";

export const selLabel = b => (b.selection_type === "number" ? `Number ${b.selection}` : b.selection);

export default function GameHistory({ setPage }) {
  const [bets, setBets] = useState(null);
  useEffect(() => { api.get("/game/history").then(r => setBets(r.data)).catch(() => setBets([])); }, []);
  return (
    <div className="screen">
      <Header title="Game history" onBack={() => setPage("account")} onBell={() => setPage("notifications")} />
      <div className="history-list">{!bets ? <div className="empty">Loading…</div> : bets.length ? bets.map(b => (
        <div className="transaction" key={b.bet_id} data-testid={`bet-${b.bet_id}`}>
          <div className="transaction-icon">🎯</div>
          <div><b>Win Go · {selLabel(b)}</b><small>Period {b.period_id} · {when(b.created_at)}</small>{b.result_number !== undefined && <small>Result · {b.result_number}</small>}</div>
          <strong className={b.status === "won" ? "green" : b.status === "lost" ? "red" : ""}>{b.status === "won" ? `+${money(b.payout)}` : money(b.amount)}<small className="bet-status">{b.status}</small></strong>
        </div>)) : <div className="empty" data-testid="empty-game-history">No game records yet</div>}</div>
    </div>
  );
}
